<template>
  <div>
    <b-card class="shadow">
      <div
        class="row animate__animated animate__fadeIn"
        v-if="!pesquisar_usuarios"
      >
        <div class="col-md-12">
          <div class="d-flex">
            <div class="mr-auto">
              <h3 class="mb-3 text-gray-800">
                {{ $t("Usuários Vinculados a este Grupo") }}
              </h3>
            </div>
            <div class="text-gray-800">
              <a
                v-if="status_vinculo == 1"
                class="router-link-exact-active active"
                @click="status_vinculo = 2"
              >
                <i class="fas fa-history"></i> Histórico de Desligamentos
              </a>
              <a
                v-else
                class="router-link-exact-active active"
                @click="status_vinculo = 1"
              >
                <i class="mdi mdi-arrow-left"></i> Voltar para Usuários
                Vinculados
              </a>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex">
            <div class="mr-auto">
              <button
                class="btn btn-sm btn-primary"
                @click="pesquisar_usuarios = true"
              >
                <i class="fas fa-plus-square" />
                {{ $t("Vincular Usuário") }}
              </button>
            </div>

            <div>
              <div class="input-group mb-3">
                <b-input
                  :placeholder="$t('Type to search')"
                  class="form-control search-input"
                  type="text"
                  v-model="search"
                  v-on:change="reiniciarPesquisa()"
                  aria-describedby="input-search"
                />
                <div class="input-group-append" role="button">
                  <span class="input-group-text" id="input-search"
                    ><i class="fas fa-search search-icon"
                  /></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
          />
          <div>
            <a v-if="!showName" @click.prevent="mostrarNome" href="#"
              ><i class="fas fa-eye"></i> Mostrar Nome de Registro</a
            >
            <a v-else @click.prevent="ocultarNome" href="#"
              ><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a
            >
          </div>
          <b-table
            :fields="[
              {
                key: 'scfv_grupo',
                label: $t('Detalhes'),
              },
              {
                key: 'cadastrado',
                label: $t('Cadastro'),
              },
              {
                key: 'status',
                label: $t('Status'),
              },
              {
                key: 'actions',
                label: '',
                class: 'text-right',
                thStyle: { width: '45px', minWidth: '45px' },
              },
            ]"
            :items="itemList"
            :responsive="true"
            striped
            hover
            show-empty
            small
            outlined
            stacked="md"
            table-class="mb-3"
          >
            <template v-slot:cell(scfv_grupo)="data">
              Usuário:
              <strong v-if="data.item.usuario">
                <span v-if="!data.item.usuario.nome_social">{{
                  data.item.usuario.nome_completo
                }}</span>
                <span v-else>
                  {{ data.item.usuario.nome_social }} (N.R.:)
                  <span v-if="showName">
                    {{ data.item.usuario.nome_completo }}
                  </span>
                </span>

                <b-link
                  :to="'/dashboard/usuario/edit/' + data.item.usuario.id"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i>
                </b-link>
              </strong>
              <br />
              Filiação 1:
              <strong v-if="data.item.usuario">{{ data.item.usuario?.mae }}</strong>
              <span v-else>Não informado</span>
              <br />
              Data de Nascimento:
              <b>{{ formatDate(data.item.usuario?.data_nascimento) }}</b>
              <br />
              Idade:
              <b>{{ calcIdade(data.item.usuario?.data_nascimento) }} ano(s)</b>
              <br />
              Está no SISC?: <b v-if="data.item.sisc">SIM</b>
              <b v-else>NÃO</b>
              <br />
              Família:
              <strong v-if="data.item.familia"> 
                <span v-if="data.item.familia.codigo_familiar"> 
                  Código Cadúnico: {{ data.item.familia.codigo_familiar }}
                </span>
                <span v-else>ID{{ data.item.familia.id }}</span>
                <b-link
                  :to="'/dashboard/familias/edit/' + data.item.familia.id"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i>
                </b-link>
              </strong>
              <span v-else>
                Não informado
              </span>
              <br />
            </template>
            <template v-slot:cell(cadastrado)="data">
              <strong>{{ data.value }}</strong>
            </template>
            <template v-slot:cell(status)="data">
              <span v-html="data.item.status_nome"></span>
            </template>

            <template v-slot:cell()="data">
              <b-button
                :title="$t('Editar')"
                :to="
                  '/dashboard/scfv/' +
                  $route.params.id +
                  '/vinculo/' +
                  data.item.id +
                  '/edit'
                "
                class="px-2 mb-0"
                size="xs"
                type="button"
                v-b-tooltip.hover
                variant="success"
              >
                <i class="mdi mdi-square-edit-outline" />
              </b-button>
            </template>
            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                  :alt="$t('No results')"
                  class="mb-5"
                  src="/img/icons/robot.svg"
                  style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>

          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  class="form-control"
                  style="width: 70px"
                  v-model="perPage"
                  v-on:change="reiniciarPesquisa"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                  v-model="page"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }}
                {{ pagination.currentPage }}
                {{ $t("of") }}
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Add
        :faixa_etaria="$parent.item.faixa_etaria"
        v-else
        @voltar="pesquisar_usuarios = false"
      />
    </b-card>
  </div>
</template>

<script>
import Add from "./usuariosvinculado/Add";

export default {
  components: { Add },
  name: "USUARIOSVINCULADOS",
  metaInfo() {
    return {
      title: this.$i18n.t("Usuários Vinculados a este Grupo"),
    };
  },
  data() {
    return {
      showName: false,
      pesquisar_usuarios: false,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      itemList: [],
      participantes: [],
      filtro: null,
      user_id: null,
      status_vinculo: 1,
    };
  },
  mounted() {
    this.getItens();
    this.$root.$on("usuariosvinculado", () => {
      this.getItens();
      this.pesquisar_usuarios = false;
    });
  },
  watch: {
    status_vinculo: function () {
      this.reiniciarPesquisa();
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return 'N/A';
      return new Date(value).toLocaleDateString('pt-BR');
    },
    calcIdade(value) {
      if (!value) return 'N/A';
      const birth = new Date(value);
      const ageDifMs = Date.now() - birth.getTime();
      const ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getItens();
      }
    },
    reiniciarPesquisa() {
      this.page = 1;
      this.getItens();
    },
    getItens() {
      this.loading = true;
      axios
        .get("api/dashboard/scfvvinculo", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            scfv_grupo_id: this.$route.params.id,
            status_vinculo: this.status_vinculo,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.itemList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.page > Math.max(1, this.pagination.totalPages)) {
            this.page = Math.max(1, this.pagination.totalPages);
            this.getItens();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
